(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function getVisiblePriceText() {
    var priceRoot = document.querySelector('[id^="product-price-"]');
    if (!priceRoot) return '';

    var price = priceRoot.querySelector('.price');
    var isOnSale = price && price.classList.contains('price--on-sale');
    var selectors = isOnSale
      ? ['.price__sale .price-item--sale', '.price-item--sale']
      : ['.price__regular .price-item--regular', '.price-item--regular'];

    for (var i = 0; i < selectors.length; i += 1) {
      var node = priceRoot.querySelector(selectors[i]);
      if (!node) continue;

      var text = node.textContent.trim();
      if (text) return text;
    }

    return '';
  }

  function findScrollTarget() {
    var candidates = Array.from(document.querySelectorAll([
      '.productView-moreItem:has([data-product-attribute])',
      '.product-form__input:not(.hidden)',
      '[data-product-attribute]',
      '.productView-action',
      '#product-add-to-cart'
    ].join(',')));

    return candidates.find(isVisibleTarget) || document.getElementById('product-add-to-cart');
  }

  function isVisibleTarget(element) {
    if (!element || element.getClientRects().length === 0) return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function highlightTarget(target) {
    if (!target || !target.classList) return;

    target.classList.add('modab-sticky-atc__target-highlight');
    window.setTimeout(function () {
      target.classList.remove('modab-sticky-atc__target-highlight');
    }, 1200);
  }

  function initSticky(root) {
    var originalButton = document.getElementById('product-add-to-cart');
    var stickyButton = root.querySelector('[data-modab-sticky-button]');
    var stickyPrice = root.querySelector('[data-modab-sticky-price]');
    var stickyMobileText = root.querySelector('.modab-sticky-atc__button-text--mobile');
    var footer = document.querySelector('footer, .footer');

    if (!originalButton || !stickyButton) return;

    var originalButtonVisible = true;
    var footerVisible = false;

    function setVisible(visible) {
      if (visible) {
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          root.classList.add('is-visible');
        });
      } else {
        root.classList.remove('is-visible');
        root.setAttribute('aria-hidden', 'true');
        window.setTimeout(function () {
          if (!root.classList.contains('is-visible')) {
            root.hidden = true;
          }
        }, 200);
      }
    }

    function syncPrice() {
      var price = getVisiblePriceText();
      if (!price) return;

      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyMobileText && !stickyButton.disabled) {
        stickyMobileText.textContent = 'Comprar ' + price;
      }
      stickyButton.setAttribute('data-mobile-price', price);
    }

    function update() {
      var buttonRect = originalButton.getBoundingClientRect();
      var originalButtonPassed = buttonRect.bottom <= 0;
      var shouldShow = originalButtonPassed && !originalButtonVisible && !footerVisible;

      setVisible(shouldShow);
      if (shouldShow) syncPrice();
    }

    var buttonObserver = new IntersectionObserver(function (entries) {
      originalButtonVisible = entries.some(function (entry) {
        return entry.isIntersecting;
      });
      update();
    }, { threshold: 0.01 });

    buttonObserver.observe(originalButton);

    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries.some(function (entry) {
          return entry.isIntersecting;
        });
        update();
      }, { threshold: 0.01 });

      footerObserver.observe(footer);
    }

    stickyButton.addEventListener('click', function () {
      var target = findScrollTarget();
      if (!target) return;

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      highlightTarget(target);

      var focusable = target.querySelector('input:not([type="hidden"]), select, button') || target;
      if (focusable && typeof focusable.focus === 'function') {
        window.setTimeout(function () {
          focusable.focus({ preventScroll: true });
        }, 350);
      }
    });

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    var priceRoot = document.querySelector('[id^="product-price-"]');
    if (priceRoot) {
      var priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }

    syncPrice();
    update();
  }

  ready(function () {
    document.querySelectorAll('[data-modab-sticky-add-to-cart]').forEach(initSticky);
  });
})();
